"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitChangeLines = splitChangeLines;
/**
 * What a suggested split would change, bucket by bucket (BEN-141 FP-017).
 *
 * The offer listed only target percentages ("Splash Fund 10% · Groceries 25% ·
 * …"): no starting point and no money, so "Update split" was a choice with no
 * way to see its consequence (Splash Fund $322.62 → $161.31 a paycheck; the debt
 * extra nearly tripled). One line per bucket whose share changes:
 * "Splash Fund 20% → 10% ($322.62 → $161.31)". Unchanged buckets are left out;
 * a bucket not in the current split counts from 0%. A current bucket missing from
 * the proposal is not listed because applying leaves it as it is
 * (`apply_allocation_recommendation` updates only the keys it proposes).
 *
 * `base` is the money the percentages split (each client's plan bucket base);
 * null shows no money. A fixed-amount bucket's money does not follow its
 * percentage, so it gets none. Each client passes its own formatters.
 */
function splitChangeLines(args) {
    const { current, proposed, base, pct, money } = args;
    return proposed.flatMap((next) => {
        const now = current.find((c) => c.key === next.key);
        const from = now?.pct ?? 0;
        if (Number(from).toFixed(2) === Number(next.pct).toFixed(2))
            return [];
        const dollars = base != null && base > 0 && now?.mode !== "amount"
            ? ` (${money((base * from) / 100)} → ${money((base * next.pct) / 100)})`
            : "";
        return [`${next.name} ${pct(from)}% → ${pct(next.pct)}%${dollars}`];
    });
}
//# sourceMappingURL=splitChangeCopy.js.map